import axios from "axios";
import qs from "query-string";

import { API_HOST } from "../config";

const requestData = qs.stringify({
  grant_type: "password",
  username: "demo@natif.ai",
  password: "kWawvuNr5qaQL5Ms"
});

const requestConfig = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded"
  }
};

export const login = () =>
  axios.post(`${API_HOST}/token`, requestData, requestConfig);
